import React, { useEffect } from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import { RECIPIENT_ADDITIONAL_INFO_SCREEN, TRANSFER_ADDITIONAL_INFO_SCREEN } from 'apps/auth/components/send/SendConstants';
import { ADDITIONAL_RECIPIENT_INFO_SHOWN, MORE_DETAILS_NEEDED_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { getOnBlurHandler } from 'apps/auth/services/sendToFieldsService';

const GTExtraToFields = (props) => {
    const { toCountry } = useExtra();
    const { extraFormDataInfo, extraFormDataSubInfo } = usePageMessages();

    useEffect(() => {
        if (__isBrowser__) {
            if (props.screen === RECIPIENT_ADDITIONAL_INFO_SCREEN) {
                props.sendAmplitudeEventOnRender?.(ADDITIONAL_RECIPIENT_INFO_SHOWN);
            } else if (props.screen === TRANSFER_ADDITIONAL_INFO_SCREEN) {
                props.sendAmplitudeEventOnRender?.(MORE_DETAILS_NEEDED_SCREEN_SHOWN);
            }
        }
    }, []);

    return (
        <div>
            <HeaderPanel title={extraFormDataInfo} subtitle={extraFormDataSubInfo} />
            <fieldset>
                {props.fields.map((field) => {
                    const onBlurHandler = getOnBlurHandler(props, field);
                    return (
                        <fieldset key={field.name}>
                            <InputAutoDetect formName={props.formName} defaultCountry={toCountry?.code} field={field} onBlurHandler={onBlurHandler} />
                        </fieldset>
                    );
                })}
            </fieldset>
        </div>
    );
};

export default GTExtraToFields;
